export default {
  actions: 'Ações',
  active: 'Ativo',
  address: 'Endereço',
  advancedFilter: 'Filtro Avançado',
  all: 'Todos',
  allCategories: 'Todas as categorias',
  allTags: 'Todas as tags',
  apply: 'Aplicar',
  appearance: 'Aparência',
  assignTag: 'Atribuir Tag',
  article: 'Artigo',
  basic: 'Básico',
  mostFrequentTopics: 'Tópicos mais frequentes',
  blog: 'Blog',
  cancel: 'Cancelar',
  catalog: 'Catálogo',
  categories: 'Categorias',
  city: 'Cidade',
  changePassword: 'Alterar Senha',
  choiceFile: 'Escolher arquivo',
  clean: 'Limpar',
  clearFilters: 'Limpar filtros',
  clearSelection: 'Limpar seleção',
  close: 'Fechar',
  colorPalette: 'Paleta de cores',
  complement: 'Complemento',
  contact: 'Contato',
  contactCell: 'Celular',
  contactCompany: 'Empresa',
  contactEmailSubject: 'Contato do site',
  contactEmailTitle: 'Novo contato enviado pelo site',
  contactMessage: 'Mensagem',
  contactName: 'Nome',
  contactPage: 'Página',
  contactPhone: 'Telefone',
  contactSentAt: 'Enviado em',
  contactServiceInterest: 'Serviço de interesse',
  continents: {
    africa: 'África',
    asia: 'Ásia',
    europe: 'Europa',
    oceania: 'Oceania',
    northamerica: 'América do Norte',
    centralamerica: 'América Central',
    southamerica: 'América do Sul',
  },
  content: 'Conteúdo',
  contentTestPrefix: 'Apenas um teste de',
  copyLink: 'Copiar link',
  copyright: '&copy; {year} &#10625; {link} &#10625; Todos os direitos reservados.',
  copyright2: 'Todos os direitos reservados.',
  cnpj: 'CNPJ',
  cpf: 'CPF',
  creditCard: 'Cartão de Crédito',
  delete: 'Excluir',
  dependencies: 'Dependências',
  Displaying: 'Exibir:',
  DisplayRecords: 'Exibindo registros %0 a %1 de %2',
  download: 'Download',
  edit: 'Editar',
  email: 'e-mail',
  emptyRecords: 'Nenhum registro para ser exibido',
  enter: 'Entrar',
  enterAPassword: 'Digite uma senha',
  enterYourMail: 'Digite seu e-mail',
  enterYourText: 'Digite seu texto aqui...',
  error: 'Erro',
  eyedropper: 'Conta-gotas',
  export: 'Exportar',
  file: 'arquivo',
  files: 'arquivos',
  fileUpload: 'Upload de Arquivos',
  filter: 'Filtrar',
  filterOptions: 'Filtrar opções...',
  FIXED_LINE: 'Telefone',
  form: 'Formulário',
  general: 'Geral',
  group: 'Agrupar',
  group1: 'Grupo',
  hello: 'Olá, {name}!',
  highlight: 'Destaque',
  home: 'Home',
  icon: 'Ícone',
  iconColor: 'Cor do ícone',
  iconName: 'Nome do Ícone',
  iconStyle: 'Estilo do ícone',
  iconType: 'Tipo de Ícone',
  icons: 'Ícones',
  included: 'Inclusos',
  inactive: 'Inativo',
  importData: 'Importar dados',
  importDownloadModelStep: '1. Baixe o modelo CSV',
  importModelInstructions: 'Preencha o modelo sem alterar os nomes das colunas.',
  downloadCsvModel: 'Baixar modelo CSV',
  importSelectFileStep: '2. Selecione o arquivo preenchido',
  confirmImport: 'Confirmar importação',
  importRejected: 'Importação rejeitada.',
  importEmpty: 'O arquivo não contém registros para importar.',
  importValidPreview: '{count} registro(s) válido(s). Confira o preview e confirme a importação.',
  importFoundErrors: '{rows} registro(s) encontrado(s), {errors} erro(s).',
  importSuccess: '{count} registro(s) importado(s).',
  importProcessError: 'Não foi possível processar o arquivo.',
  importErrorRequired: 'Campo obrigatório.',
  importErrorDateFormat: 'Formato esperado: YYYY-MM-DD.',
  importErrorDatetimeFormat: 'Formato esperado: YYYY-MM-DD HH:mm:ss.',
  importErrorNumber: 'Informe um número válido.',
  importErrorBoolean: 'Use true/false, sim/não ou 1/0.',
  importErrorAllowedValues: 'Valor permitido: {values}.',
  line: 'Linha',
  moreRecords: 'Mais {count} registro(s).',
  info: 'Informação',
  inSight: 'À vista',
  inThisArticle: 'Neste artigo',
  learnMore: 'Saiba mais',
  language: 'Idioma',
  list: 'Lista',
  listOf: 'Lista de {name}',
  loadMore: 'Carregar mais',
  loading: 'Carregando...',
  loadingIcons: 'Carregando ícones…',
  login: 'Login',
  logout: 'Sair',
  menu: 'Menu',
  messageSentSuccessfully: 'Mensagem enviada com sucesso.',
  MOBILE: 'Celular',
  modules: 'Módulos',
  moduleUnavailableRegion: 'Módulo não disponível para essa região',
  moduleComingSoon: 'Em breve',
  moduleTrialRestricted: 'Indisponível na avaliação gratuita',
  mfaEmail: 'E-mail',
  mfaAuthApp: 'Aplicativo autenticador',
  moreColors: 'Mais cores…',
  multiSortHint: 'Shift + clique: ordenar por múltiplas colunas',
  myProfile: 'Meu perfil',
  companyData: 'Dados da Empresa',
  companyRegistration: 'Dados cadastrais',
  companyName: 'Razão social',
  tradeName: 'Nome fantasia',
  stateRegistration: 'Inscrição estadual',
  municipalRegistration: 'Inscrição municipal',
  foundationDate: 'Data de fundação',
  companyNameRequired: 'Informe a razão social.',
  profileIdentification: 'Identificação',
  profileContacts: 'Contatos',
  profileAddress: 'Endereço',
  profilePhoto: 'Foto do perfil',
  fullName: 'Nome completo',
  socialName: 'Nome social',
  nickname: 'Como quer ser chamado',
  birthDate: 'Data de nascimento',
  gender: 'Gênero',
  genderMale: 'Masculino',
  genderFemale: 'Feminino',
  genderNonBinary: 'Não binário',
  genderNotInformed: 'Prefiro não informar',
  country: 'País',
  document: 'Documento',
  documentNumber: 'Número do documento',
  profileEmail: 'E-mail de acesso',
  profilePhone: 'Celular pessoal',
  profileDisplayNameRequired: 'Informe nome completo, nome social ou como quer ser chamado.',
  profilePhoneInvalid: 'Informe um celular válido.',
  profileAddressIncomplete: 'Preencha CEP, endereço, cidade e país para salvar o endereço.',
  navigation: 'Navegação',
  newsletterEmail: 'Seu melhor e-mail',
  newsletterName: 'Como gostaria de ser chamado?',
  newsletterSubscriptionSuccess: 'Inscrição realizada com sucesso.',
  newsletterSubscriptionExists: 'Este e-mail já está cadastrado.',
  neighborhood: 'Bairro',
  notifications: 'Notificações',
  notificationsEmail: 'E-mail',
  notificationsPush: 'Push',
  new: 'Novo',
  next: 'Próxima',
  noIconsFound: 'Nenhum ícone encontrado',
  noOptions: 'Não há opções disponíveis',
  no: 'Não',
  notice: 'Aviso',
  notFoundPage: 'A página que você está procurando não existe.',
  notFoundPage2: 'Você pode ter digitado<br>incorretamente o endereço ou a<br>página pode ter sido removida.',
  notFoundPage3: 'Ir para a página principal',
  number: 'Número',
  ok: 'OK',
  order: 'Ordem',
  password: 'Senha',
  passwordStrength: 'Força da senha',
  passwordStrenght: 'Força da senha',
  print: 'Imprimir',
  product: 'Produto',
  preferences: 'Preferências',
  preferencesSaved: 'Preferências salvas.',
  preferredMfaMethod: 'Método preferencial de autenticação em duas etapas',
  preferredMfaMethodHelp: 'Define o método usado por padrão no próximo desafio de autenticação.',
  page: 'Página',
  parent: 'Parent',
  preview: 'Preview',
  question: 'Pergunta',
  rangeFrom: 'de',
  rangeTo: 'até',
  readArticle: 'Ler artigo ',
  readTime: '{minutes} min de leitura',
  recentContent: 'Conteúdos recentes',
  relatedArticles: 'Artigos relacionados',
  recordPerPage: 'registros por página',
  recommendations: 'Recomendações',
  removeSelection: 'Remover {name}',
  registration: 'Registro',
  technicalName: 'Nome técnico',
  rg: 'RG',
  save: 'Salvar',
  send: 'Enviar',
  search: 'Pesquisar...',
  searchIcon: 'Pesquisar ícone…',
  select: 'Selecione...',
  selectColor: 'Selecionar cor',
  selectIcon: 'Selecionar ícone',
  services: 'Serviços',
  security: 'Segurança',
  seo: 'SEO',
  analyzeSeo: 'Analisar SEO',
  shareArticle: 'Compartilhar artigo',
  shareOnFacebook: 'Compartilhar no Facebook',
  shareOnLinkedIn: 'Compartilhar no LinkedIn',
  shareOnWhatsApp: 'Compartilhar no WhatsApp',
  shareOnX: 'Compartilhar no X',
  sharePrompt: 'Compartilhe:',
  siteAccessPlatform: 'Acessar plataforma',
  siteBrand: 'Núcleo P',
  sitePublicationPreparing: 'Publicação em preparação',
  siteTalkToTeam: 'Falar com a equipe',
  siteUnavailable: 'Serviço temporariamente indisponível',
  siteUnavailableDescription: 'Não foi possível carregar esta página agora. Tente novamente em instantes.',
  signup: 'Cadastre-se',
  source: 'Origem',
  status: 'Status',
  strong: 'Forte',
  structuralNavigation: 'Navegação estrutural',
  tags: 'Tags:',
  success: 'Sucesso',
  target: 'Destino',
  template: 'Template',
  text: 'Texto',
  theme: 'Tema',
  themeLight: 'Claro',
  themeDark: 'Escuro',
  themeSystem: 'Sistema',
  interfaceScale: 'Escala da interface',
  scaleCompact: 'Compacta',
  scaleDefault: 'Padrão',
  scaleConfort: 'Confortável',
  timezone: 'Fuso horário',
  total: 'Total',
  uf: 'UF',
  updateMenu: 'Atualizar menu',
  updateMenuSuccess: 'Menu atualizado.',
  upload:'Upload',
  url: 'URL',
  value: 'Valor',
  view: 'Ver',
  viewAllArticles: 'Ver todos os artigos',
  visible: 'Visível',
  warning: 'Atenção',
  weakFemale: 'Fraca',
  whatsappChat: 'Conversar pelo WhatsApp',
  openArticle: 'Abrir artigo: {title}',
  openService: 'Abrir serviço: {title}',
  blogInsights: 'Insights para organizar e evoluir seu negócio.',
  yes: 'Sim',
  yn: 'Confirmação necessária',
  zip: 'CEP'
};
